<template>
  <div class="booking-calendar">
    <b-container fluid>
      <b-row align-v="center">
        <b-col style="font-size: 1.5rem;">
          <b-button @click="changeMonth('prev')" size="sm" variant="primary" :disabled="this.isLoading"><b-icon icon="arrow-left"></b-icon></b-button>
          <label class="mx-2">{{year}} / {{monthNames[month]}}</label>
          <b-button @click="changeMonth('next')" size="sm" variant="primary" :disabled="this.isLoading"><b-icon icon="arrow-right"></b-icon></b-button>
        </b-col>
      </b-row>
      <p v-if="!this.isLoading && this.bookings.length == 0 && this.style != 'monthly'">No records.</p>
      <b-spinner v-if="this.isLoading" variant="primary" label="Spinning"></b-spinner>
      <b-row v-if="this.style == 'monthly' && !this.isLoading" class="monthly">
        <b-col cols="4" lg="2" v-for="(day, index) in this.months[month]" :key="'day' + index" class="day-grid">
          <p>{{day.day}}</p>
          <div class="event-block" v-for="(booking, i) in day.bookings" :key="'bookings' + i">
            <p class="event-name" @click="showDetails(booking)">{{booking.follower}} - {{booking.customer_name}}</p>
            <p class="event-name" @click="showDetails(booking)">{{booking.time}}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- VIEW BOOKING -->
    <b-modal id="modal-view-booking" hide-footer title="View booking">
      <b-form @submit.prevent="add_booking">
        <strong>Create Date:</strong>
        <p>{{this.viewed_booking.created_date}}</p>

        <strong>Date:</strong>
        <p>{{this.viewed_booking.date}}</p>

        <strong>Time:</strong>
        <p>{{this.viewed_booking.time}}</p>

        <strong>Customer Name:</strong>
        <p>{{this.viewed_booking.customer_name}}</p>

        <strong>Customer Phone:</strong>
        <p>{{this.viewed_booking.customer_phone}}</p>

        <strong>Customer Email:</strong>
        <p>{{this.viewed_booking.email}}</p>

        <strong>How did you find us:</strong>
        <p>{{this.viewed_booking.how_did_you_find_us}}</p>

        <strong>Cemetery Name:</strong>
        <p>{{this.viewed_booking.cemetery_name}}</p>

        <strong>Funeral Provider:</strong>
        <p>{{this.viewed_booking.funeral_provider}}</p>

        <strong>Who is following:</strong>
        <p>{{this.viewed_booking.follower}}</p>

        <strong>Customer Enquiry:</strong>
        <p>{{this.viewed_booking.customer_enquiry}}</p>
          
        <div class="modal-footer">
          <b-button @click="hideModal('modal-view-booking')"> Return </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default ({
  name: "QuoteCalendar",
  props: {
    user: Object
  },
  data() {
    return {
      maleMonth: [4, 6, 9, 11],
      isLoading: false,
      date: "",
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      viewed_booking: {},
      year: 0,
      month: 0,
      yearMonth: "",
      bookings: [],
      style: "monthly",
      months: [],
    }
  },
  mounted() {
    this.yearMonth = this.year + '-' + String(this.month + 1).padStart(2, '0');
  },
  watch: {
    yearMonth(newYearMonth) {
      this.filterByYearMonth(newYearMonth);
    },
  },
  created() {
    this.initiateMonths();
    var today = new Date();
    this.month = today.getMonth();
    this.year = today.getFullYear();
  },
  methods: {
    changeMonth(mode) {
      //console.log(this.months);
      if (mode == "next") {
        if (this.month + 1 > 11) {
          this.month = (this.month + 1) % 12;
          this.year += 1;
        } else {
          this.month += 1;
        }
      } else if (mode == "prev") {
        if (this.month - 1 < 0) {
          this.month = 11;
          this.year -= 1;
        } else {
          this.month -= 1;
        }
      }

      this.yearMonth = this.year + '-' + String(this.month + 1).padStart(2, '0');
    },
    filterByYearMonth(yearMonth) {
      const self = this;
      // if(this.user.role == 'sales') {
      //   firebase.firestore().collection('bookings')
      //   .where("follower","==",this.user.name)
      //   .where("year_month", "==", yearMonth)
      //   .onSnapshot((collection) => {
      //     if (collection.docs.length > 0) {
      //       this.initiateMonths();
      //       collection.docs.forEach(doc => {
      //         const index = doc.data().day - 1;
      //         const booking = doc.data();

      //         self.bookings.push(booking);
      //         self.months[self.month][index].bookings.push(booking)
      //       })
      //     }
      //   });
      // } else {
      //   firebase.firestore().collection('bookings')
      //   .where("year_month", "==", yearMonth)
      //   .onSnapshot((collection) => {
      //     if (collection.docs.length > 0) {
      //       this.initiateMonths();
      //       collection.docs.forEach(doc => {
      //         const index = doc.data().day - 1;
      //         const booking = doc.data();
              
      //         self.bookings.push(booking);
      //         self.months[self.month][index].bookings.push(booking);
      //       })
      //     }
      //   });
      // }
      firebase.firestore().collection('bookings')
        .where("year_month", "==", yearMonth)
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            this.initiateMonths();
            collection.docs.forEach(doc => {
              const index = doc.data().day - 1;
              const booking = doc.data();
              
              self.bookings.push(booking);
              self.months[self.month][index].bookings.push(booking);
            })
          }
        });
    },
    showDetails(booking) {
      this.viewed_booking = booking;
      this.showModal('modal-view-booking');
    },
    changeStyle(style) {
      this.style = style;
    },
    initiateMonths() {
      this.months = [];
      for (var i = 0; i < 12; i++) {
        var numberOfDays = 31;
        if (this.maleMonth.includes(i + 1)) {
          numberOfDays = 30;
        } else if (i + 1 == 2) {
          numberOfDays = 29;
        }
        var month = [];
        for (var c = 0; c < numberOfDays; c++) {
          month.push({day: c+1, 
            bookings: []});
        }
        this.months.push(month);
      }
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
  },
})
</script>

<style>
.booking-calendar {
  margin: 0;
}

.booking-calendar .worker-name {
  margin: 0;
}

.booking-calendar .day-grid {
  border: 1px solid #000;
  min-height: 100px;
}

.booking-calendar .day-grid p{
  margin: 0;
}

.booking-calendar .day-grid .event-name {
  margin: 0;
  padding: 0;
  color: blue;
  display: block;
  text-decoration: underline;
  cursor: pointer;
}

.booking-calendar .day-grid .event-badge {
  margin: 0;
  display: inline;
}

.booking-calendar .event-name {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.booking-calendar .event-block {
  padding: 1px;
  margin-bottom: 1rem;
  border: 1px solid gainsboro;
  border-radius: 5px;
}

.booking-calendar .active {
  color: green;
}

.booking-calendar .completed {
  color: gray;
}

.booking-calendar .namebadege {
  margin: 0;
}
</style>